import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../components/auth/auth.service';
import { ApiService } from '../../service/api_service';


@Component({
    selector: 'app-productpricelist',
    template: require('./productpricelist.component.html'),
    styles: [require('./productpricelist.component.css')],
    viewProviders: [ApiService]
})
export class ProductPriceListComponent implements OnInit {
    static parameters = [ApiService, AuthService];


    private columnDefs;
    api: any;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    productData;
    constructor(private apiService: ApiService, private authService: AuthService) {
        this.apiService = apiService;
        this.columnDefs = [];

        this.defaultColDefine = { resizable: true };

    }
    ngOnInit() {
        this.getProductList();
        this.authService.getProductList();
    }
    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'sales' });
    }

    sizeToFit(skipHeader) {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    }

    getProductList() {
        this.productData = [{ "Code": 101, "Product Name": "Meidcine", "PackSize": 10, "MRP": 12 }];
        console.log('productData', this.productData);
        if (this.productData.length > 0) {
            let column = Object.keys(this.productData[0]);
            console.log('columns', column);
            // gridOptions.api.setColumnDefs(column);
            let dynamicColumnDef: any = [];
            column.forEach(data => {
                let demo: any = {
                    headerName: data.toString(),
                    field: data.toString()
                };
                dynamicColumnDef.push(demo);

            });
            this.columnDefs = dynamicColumnDef;
        }
    }


}